export const calculateBmi = (weightInKg: number, heightInCm: number): number => {
    const toSquare = 2;

    const sizeInMeter = heightInCm / 100; // eslint-disable-line @typescript-eslint/no-magic-numbers

    return weightInKg / sizeInMeter ** toSquare;
};
